import Title from "components/title/Title";
import React from "react";
import styles from "./MuseumSection.module.scss";
import MuseumCard from "components/cards/museumCard/MuseumCard";

const MuseumSection = () => {
  return (
    <div className={styles.museumSectionContainer}>
      <div className="container">
        <Title text={"Museum"} bottomStrokeWidth={"49%"} />
        <div className={styles.museumList}>
          <MuseumCard />
          <MuseumCard />
          <MuseumCard />
          <MuseumCard />
        </div>
        <div className={styles.viewAllCentered}>View All</div>
      </div>
    </div>
  );
};

export default MuseumSection;
